module.exports = __webpack_public_path__ + "img/template-circle-1.7e0606ac.png";